import { render, staticRenderFns } from "./advertisingManage.vue?vue&type=template&id=6073bc31&scoped=true"
import script from "./advertisingManage.vue?vue&type=script&lang=js"
export * from "./advertisingManage.vue?vue&type=script&lang=js"
import style0 from "./advertisingManage.vue?vue&type=style&index=0&id=6073bc31&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6073bc31",
  null
  
)

export default component.exports